import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import worriedKiwi from '../../images/worriedKiwi.png';
import styles from './dropIn.module.css';
import Header from '../../components/UIContainer/MobileUI/header/index';
import { go } from '../../routes/index';
import { isDesktop } from '../../config';
import { ReactComponent as RightArrow } from '../../svgs/rightarrow.svg';
import { actions as feelingActions } from '../Reason/actions/actions';
import { ActionTypes } from '../constants/actionTypes';


const DropIn = ({ updateSession, ...props }) => {
    const history = useHistory();
    const { actionId } = useParams();
    const practice = props.location.state.practice;

    const renderDropInCare = () => (
        <div className={styles.container}>
            <img src={worriedKiwi} className={styles.feelingIcon} alt='No booking required' />
            <div className={styles.labelSmall}>
                <b>This service may not be right for you.</b>
            </div>
            <div className={styles.labelSmall}>
                Based on the symptoms you've selected, we recommend visiting a same-day/urgent care service.
            </div>
            <div className={styles.labelSmall}>
                Our <b>Drop-inCare</b> service is available to <b>enrolled WeCare patients</b>. Drop-inCare is available at WeCare Wigram & WeCare Lincoln for same-day assessment - no appointment needed.
            </div>
            <div className={styles.labelSmall}>
                If you are not currently enrolled with WeCare but wish to enrol, you can visit our website or a WeCare clinic to enrol now.
            </div>
        </div>
    );

    const renderDropInOrBook = () => (
        <div className={styles.container}>
            <img src={worriedKiwi} className={styles.feelingIcon} alt='No booking required' />
            <div className={styles.labelSmall}>
                <b>This service may not be right for you.</b>
            </div>
            <div className={styles.labelSmall}>
                Based on the symptoms you've selected, we recommend consulting an advanced clinician regarding your health concern.
            </div>
            <div className={styles.labelSmall}>
                If you are an enrolled WeCare patient please either book a <b>GeneralPractice Medical Consult</b> OR alternatively use our <b>Drop-inCare</b> service, available at WeCare Wigram & WeCare Lincoln for same-day assessment - no appointment needed.
            </div>
            <div className={styles.labelSmall}>
                <b>If you are NOT enrolled with WeCare</b> please consult your usual medical provider or attend an urgent care centre.
            </div>
            <div className={styles.labelSmall}>
                If you are not currently enrolled with WeCare but wish to enrol, you can visit our website or a WeCare clinic to enrol now.
            </div>
        </div>
    );

    const renderBookConsult = () => (
        <div className={styles.container}>
            <img src={worriedKiwi} className={styles.feelingIcon} alt='No booking required' />
            <div className={styles.labelSmall}>
                <b>This service may not be right for you.</b>
            </div>
            <div className={styles.labelSmall}>
                Based on the symptoms you've selected, we recommend consulting an advanced clinician regarding your health concern.
            </div>
            <div className={styles.labelSmall}>
                If you are an enrolled WeCare patient please book a <b>GeneralPractice Medical Consult</b> OR alternatively use our <b>Drop-inCare</b> service, available at WeCare Wigram & WeCare Lincoln for same-day assessment - no appointment needed.
            </div>
            <div className={styles.labelSmall}>
                <b>If you are NOT enrolled with WeCare</b> please consult your usual medical provider.
            </div>
            <div className={styles.labelSmall}>
                If you are not currently enrolled with WeCare but wish to enrol, you can visit our website or a WeCare clinic to enrol now.
            </div>
        </div>
    );

    const renderOutOfNZ = () => (
        <div className={styles.container}>
            <img src={worriedKiwi} className={styles.feelingIcon} alt='No booking required' />
            <div className={styles.labelSmall}>
                <b>The Online Medical Certificate service is only available to people living in New Zealand.</b>
            </div>
            <div className={styles.labelSmall}>
                Please note that we will not supply medical certificates to anyone living outside New Zealand and, in this case, your request will not be processed.
            </div>
        </div>
    );

    const renderEmergency = () => (
        <div className={styles.container}>
            <img src={worriedKiwi} className={styles.feelingIcon} alt='No booking required' />
            <div className={styles.labelSmall}>
                <b>It sounds like you need immediate medical attention. </b>
            </div>
            <div className={styles.labelSmall}>
                Please dial 111 for an ambulance or attend your nearest emergency department.
            </div>
        </div>
    );

    const renderNeedsSmear = () => (
        <div className={styles.container}>
            <img src={worriedKiwi} className={styles.feelingIcon} alt='No booking required' />
            <div className={styles.labelSmall}>
                <b>It sounds like you need a full cervical smear</b> with speculum examination (a traditional smear rather than self-swabs).
            </div>
            <div className={styles.labelSmall}>
                Please book using the ‘<b>Cervical Screening (Full Smear Test)</b>’ option at your preferred CareNow location.
            </div>
        </div>
    );

    const renderOpenWound = () => (
        <div className={styles.container}>
            <img src={worriedKiwi} className={styles.feelingIcon} alt='No booking required' />
            <div className={styles.labelSmall}>
                It sounds like you have an open wound.
            </div>
            <div className={styles.labelSmall}>
                Please book using the ‘<b>Minor Wounds, Cuts & Grazes</b>’ option at your preferred CareNow location.
            </div>
        </div>
    );


    const getContent = (actionId) => {
        switch (Number(actionId)) {
            case ActionTypes.EXIT_DROP_IN_CARE:
                return renderDropInCare();
            case ActionTypes.EXIT_DROP_IN_OR_BOOK:
                return renderDropInOrBook();
            case ActionTypes.EXIT_BOOK_CONSULT:
                return renderBookConsult();
            case ActionTypes.EXIT_OUT_OF_NZ:
                return renderOutOfNZ();
            case ActionTypes.EXIT_EMERGENCY:
                return renderEmergency();
            case ActionTypes.EXIT_NEEDS_SMEAR:
                return renderNeedsSmear();
            case ActionTypes.EXIT_OPEN_WOUND:
                return renderOpenWound();
            default:
                return renderDropInCare();
        }
    };

    return (
        <div className={styles.feelingPage}>
            {!isDesktop() && <Header goBackFn={() => history.goBack()} headerClassNames={styles.header} showHelp />}
            {getContent(actionId)}

            {isDesktop() ? (
                <div className={styles.nextContainer}>
                    <button className={styles.navLinkLarge} style={{ visibility: "hidden" }} onClick={() => history.goBack()}>
                        <RightArrow className={styles.backwardArrow} />
                        <span>Back</span>
                    </button>
                    <button className={styles.navLinkLarge} onClick={() => go.practiceProfile(practice.UrlName)}>
                        <span>Book medical consult</span>
                    </button>
                </div>
            ) : (
                <div className={styles.footer}>
                    <button 
                        className={styles.bookButton}
                        onClick={() => { go.practiceProfile(practice.UrlName); }}
                    >
                        Book medical consult
                    </button>
                </div>
            )}
        </div>
    )
}

const mapStateToProps = state => ({
    practice: state.practiceProfileReducer.profile
})

const mapDispatchToProps = dispatch => ({
    updateSession: bindActionCreators(feelingActions.updateSession, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(DropIn);